import React, { useState, useEffect, useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";

import { Modal } from "react-bootstrap";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../provider/ServiceProvider";
import { AiFillCloseCircle } from "react-icons/ai";
import "./SIDdisclosures.css";
// import animation from '../../../images/jm-animation.gif';
import DefinationndInterpretation from "./DefinationndInterpretation/DefinationndInterpretation";
import SchemeDifferentiation from "./SchemeDifferentiation/SchemeDifferentiation";
import SchemeExpenseRatio from "./SchemeExpenseRatio/SchemeExpenseRatio";
import Weblink from "../SIDdisclosures/Weblink/Weblink";
import LoadStructure from "../SIDdisclosures/LoadStructure/LoadStructure";

import AditioanlSchemeRelated from "../SIDdisclosures/AditioanlSchemeRelated/AditioanlSchemeRelated";

import { useNavigate, useLocation } from "react-router-dom";
import Penaltiesndpending from "../SIDdisclosures/PenaltiesndPending/Penaltiesndpending";
import { trackEvent, trackPageView } from "../utils/tracking";

function SIDdisclosures() {
  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/SIDdisclosures",
      "jmf_sid-disclosures_landing"
    );
    // trackPageView("http://localhost:710/SIDdisclosures", "jmf_sid-disclosures_landing");

    trackEvent({
      category: "Static Page",
      action: "SIDdisclousers Page Loaded",
      label: "jmf_sid-disclosures_landing",
      value: 1,
    });
  }, []);

  const [activeTab, setActiveTab] = useState("Scheme Differentiation");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    const tabName = pathname
      .substring(pathname.lastIndexOf("/") + 1)
      .replace(/-/g, " ");

    // Check if the tab name is valid, otherwise default to "Scheme Differentiation"
    if (tabNameIsValid(tabName)) {
      setActiveTab(tabName);
    } else {
      setActiveTab("Scheme Differentiation");
    }
  }, [location.pathname]);

  const tabNameIsValid = (tabName) => {
    return [
      "Scheme Differentiation",
      "Additional Scheme Related Disclosures",
      "Scheme Expense Ratio",
      "Load Structure",
      "Definitions interpretation",
      "Weblink",
      "Penaltiesndpending",
    ].includes(tabName);
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    navigate(`/SIDdisclosures/${tabName.replace(/\s+/g, "-")}`);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "Scheme Differentiation":
        return <SchemeDifferentiation />;
      case "Additional Scheme Related Disclosures":
        return <AditioanlSchemeRelated />;
      case "Scheme Expense Ratio":
        return <SchemeExpenseRatio />;
      case "Load Structure":
        return <LoadStructure />;
      case "Definitions interpretation":
        return <DefinationndInterpretation />;
      case "Weblink":
        return <Weblink />;
      case "Penaltiesndpending":
        return <Penaltiesndpending />;
      default:
        return null;
    }
  };

  return (
    <main>
    <section className="trustee-sc product-main">
      <Container>
        <Row>
          <Col sm={12}>
            <div className="section-header">
              <h1>SID Related Disclosures</h1>
            </div>
          </Col>
          <Col sm={12}>
            <Row className="padd15top">
              <Col sm={4}>
              <div role="tablist" aria-label="SID Related Disclosures Tabs">
                <div
                  className={
                    activeTab === "Scheme Differentiation"
                      ? "aboutusactive"
                      : "aboutusinactive"
                  }
                >
                  <button
                  role="tab"
                  type="button"
                  aria-selected={activeTab === "Scheme Differentiation"}
                  // style={{background : "transparent"}}
                  className={
                      activeTab === "Scheme Differentiation"
                        ? "aboutusactivetext cursorpointer"
                        : "cursorpointer"
                    }
                    onClick={() => handleTabClick("Scheme Differentiation")}
                  >
                    Scheme Differentiation
                  </button>
                </div>

                <div
                  className={
                    activeTab === "Additional Scheme Related Disclosures"
                      ? "aboutusactive"
                      : "aboutusinactive"
                  }
                >
                  <button
                  role="tab"
                  type="button"
                  aria-selected={activeTab === "Additional Scheme Related Disclosures"}
                  className={
                      activeTab === "Additional Scheme Related Disclosures"
                        ? "aboutusactivetext cursorpointer"
                        : "cursorpointer"
                    }
                    onClick={() =>
                      handleTabClick("Additional Scheme Related Disclosures")
                    }
                  >
                    Additional Scheme Related Disclosures
                  </button>
                </div>

                <div
                  className={
                    activeTab === "Scheme Expense Ratio"
                      ? "aboutusactive"
                      : "aboutusinactive"
                  }
                >
                  <button
                  role="tab"
                  type="button"
                  aria-selected={activeTab === "Scheme Expense Ratio"}
                    className={
                      activeTab === "Scheme Expense Ratio"
                        ? "aboutusactivetext cursorpointer"
                        : "cursorpointer"
                    }
                    onClick={() => handleTabClick("Scheme Expense Ratio")}
                  >
                    Scheme Expense Ratio
                  </button>
                </div>

                <div
                  className={
                    activeTab === "Load Structure"
                      ? "aboutusactive"
                      : "aboutusinactive"
                  }
                >
                  <button
                  role="tab"
                  type="button"
                  aria-selected={activeTab === "Load Structure"}
                    className={
                      activeTab === "Load Structure"
                        ? "aboutusactivetext cursorpointer"
                        : "cursorpointer"
                    }
                    onClick={() => handleTabClick("Load Structure")}
                  >
                    Load Structure
                  </button>
                </div>
                <div
                  className={
                    activeTab === "Definitions interpretation"
                      ? "aboutusactive"
                      : "aboutusinactive"
                  }
                >
                  <button
                  role="tab"
                  type="button"
                  aria-selected={activeTab === "Definitions interpretation"}
                    className={
                      activeTab === "Definitions interpretation"
                        ? "aboutusactivetext cursorpointer"
                        : "cursorpointer"
                    }
                    onClick={() => handleTabClick("Definitions interpretation")}
                  >
                    Definitions/interpretation
                  </button>
                </div>
                <div
                  className={
                    activeTab === "Weblink"
                      ? "aboutusactive"
                      : "aboutusinactive"
                  }
                >
                  <button
                  role="tab"
                  type="button"
                  aria-selected={activeTab === "Weblink"}
                    className={
                      activeTab === "Weblink"
                        ? "aboutusactivetext cursorpointer"
                        : "cursorpointer"
                    }
                    onClick={() => handleTabClick("Weblink")}
                  >
                    Weblink
                  </button>
                </div>
                <div
                  className={
                    activeTab === "Penaltiesndpending"
                      ? "aboutusactive"
                      : "aboutusinactive"
                  }
                >
                  <button
                  role="tab"
                  type="button"
                  aria-selected={activeTab === "Penaltiesndpending"}
                    className={
                      activeTab === "Penaltiesndpending"
                        ? "aboutusactivetext cursorpointer"
                        : "cursorpointer"
                    }
                    onClick={() => handleTabClick("Penaltiesndpending")}
                  >
                    Penalties and Pending Litigation
                  </button>
                </div>
              </div>
              </Col>
              <Col sm={8}>{renderTabContent()}</Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
    </main>
  );
}

export default SIDdisclosures;
